import React, { useEffect, useRef, useState } from "react";
import ExifReader from "exifreader";
// SurveyJs Utilities
import { SurveyCreatorComponent, SurveyCreator } from "survey-creator-react";
import {
  ElementFactory,
  Serializer,
  SvgRegistry,
  ComponentCollection,
  surveyLocalization,
  IElement,
  QuestionMatrixDynamicModel,
} from "survey-core";
import {
  localization,
  PropertyGridEditorCollection,
  SurveyQuestionEditorDefinition,
} from "survey-creator-core";
import { ReactQuestionFactory, Survey } from "survey-react-ui";
import { settings } from "survey-core";
settings.useCachingForChoicesRestfull = false;
// Panels
import riverConditionPanel from "view/pages/Forms/EditFormDetails/Components/SurveyJs/panels/riverCondition";
import gpsInfoPanel from "view/pages/Forms/EditFormDetails/Components/SurveyJs/panels/gpsInfo";
import speciesDetailsPanel from "view/pages/Forms/EditFormDetails/Components/SurveyJs/panels/speciesDetails";
import countDetailsPanel, {
  countDetailsIcon,
} from "view/pages/Forms/EditFormDetails/Components/SurveyJs/panels/countDetails";
import sightingDetailsPanel from "view/pages/Forms/EditFormDetails/Components/SurveyJs/panels/sightingDetails";
import weatherConditionsPanel from "view/pages/Forms/EditFormDetails/Components/SurveyJs/panels/weathreConditions";
import generalInfoPanel from "view/pages/Forms/EditFormDetails/Components/SurveyJs/panels/generalInfo";
// import geographicalInfo from "./panels/geographicalInfo";
// import harvest from "./panels/harvest";
import sample from "./panels/sample";

// Custom question components
import SurveyAudioQuestion, {
  audioProperties,
} from "view/pages/Forms/EditFormDetails/Components/SurveyJs/components/Audio";
import SurveyGeoCoderQuestion, {
  geoCoderProperties,
} from "view/pages/Forms/EditFormDetails/Components/SurveyJs/components/Geocoder";

// Questions Models
import QuestionAudioModel from "view/pages/Forms/EditFormDetails/Components/SurveyJs/components/Audio/model";
import QuestionGeoCoderModel from "view/pages/Forms/EditFormDetails/Components/SurveyJs/components/Geocoder/model";

// Icons
import audioIcon from "view/pages/Forms/EditFormDetails/Components/SurveyJs/components/Audio/icon";
import regionIcon from "view/pages/Forms/EditFormDetails/Components/SurveyJs/components/RegionPicker/icon";
import phoneNumberIcon from "view/pages/Forms/EditFormDetails/Components/SurveyJs/components/PhoneNumber/icon";
import geoCoderIcon from "view/pages/Forms/EditFormDetails/Components/SurveyJs/components/Geocoder/icon";
import shapePickerIcon from "view/pages/Forms/EditFormDetails/Components/SurveyJs/components/ShapePicker/icon";
import pointPickerIcon from "view/pages/Forms/EditFormDetails/Components/SurveyJs/components/PointPicker/icon";
import drawPolygonIcon from "view/pages/Forms/EditFormDetails/Components/SurveyJs/components/DrawPolygon/icon";
import dropPinIcon from "view/pages/Forms/EditFormDetails/Components/SurveyJs/components/DropPin/icon";
import getGpsDataIcon from "view/pages/Forms/EditFormDetails/Components/SurveyJs/components/GetGpsData/icon";
import gpsCoordinatesIcon from "view/pages/Forms/EditFormDetails/Components/SurveyJs/components/GpsCoordinates/icon";
import { generalIcon } from "view/pages/Forms/EditFormDetails/Components/SurveyJs/panels/generalInfo";
import { weatherIcon } from "view/pages/Forms/EditFormDetails/Components/SurveyJs/panels/weathreConditions";
import { sightingIcon } from "view/pages/Forms/EditFormDetails/Components/SurveyJs/panels/sightingDetails";
import { harvestIcon } from "view/pages/Forms/EditFormDetails/Components/SurveyJs/panels/harvest";
import { speciesDetailIcon } from "view/pages/Forms/EditFormDetails/Components/SurveyJs/panels/speciesDetails";
import { geographicalIcon } from "view/pages/Forms/EditFormDetails/Components/SurveyJs/panels/geographicalInfo";
import { gpsIcon } from "view/pages/Forms/EditFormDetails/Components/SurveyJs/panels/gpsInfo";
import { riverIcon } from "view/pages/Forms/EditFormDetails/Components/SurveyJs/panels/riverCondition";
import { sampleIcon } from "./panels/sample";

import questionTypes from "./questionTypes";
import { panelsName } from "./panelsTitle";
import questionsPropertiesToBeRemove from "./questionsPropertiesToBeRemove";
import surveyJsPropertiesToKeep from "./surveyJsPropertiesToKeep";

import { Header } from "view/pages/Forms/EditFormDetails/Components/SurveyJs/components/Header";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { resetFormDetailsAction } from "store/formDetails/reducer.actions";
import { ThunkDispatch } from "redux-thunk";
import { AnyAction } from "redux";
import { useSelector } from "react-redux";
import store, { RootState } from "store";
import QuestionShapePickerModel from "./components/ShapePicker/model";
import SurveyShapePickerQuestion, {
  shapePickerProperties,
} from "./components/ShapePicker";
import { createPortal, flushSync } from "react-dom";
import { createRoot } from "react-dom/client";
import { updateDeletedQuestionEle } from "store/surveyJS";
import {
  CustomPropertyGridSidebar,
  HandlerComponent,
} from "./helperComponents";
import togglePropertyGridSidebar from "./utils/togglePropertyGridSidebar";
import toggleCustomPropertyGridSidebar from "./utils/toggleCustomPropertyGridSidebar";
import structureFormJSON from "./utils/structureFormJSON";
import registerCustomPropertyGridSidebar from "./utils/registerCustomPropertyGridSidebar";
import QuestionPointPickerModel from "./components/PointPicker/model";
import QuestionPhoneNumberModel from "./components/PhoneNumber/model";
import SurveyPointPickerQuestion, {
  pointPickerProperties,
} from "./components/PointPicker";
import {
  updateAddedGeographicalPanelMapQuestions,
  updateAddedHarvestPanelMapQuestions,
  updateAddedQuestionState,
  updateAllCommunityLayers,
  updateSelectedQuestionEle,
  updateSurveyActiveTab,
} from "store/surveyJS/reducer.actions";
import QuestionDrawPolygonModel from "./components/DrawPolygon/model";
import SurveyDrawPolygonQuestion, {
  drawPolygonProperties,
} from "./components/DrawPolygon";
import "survey-core/survey.i18n.js";
import "survey-creator-core/survey-creator-core.i18n.js";
import "survey-core/defaultV2.css";
import "survey-creator-core/survey-creator-core.css";
import "view/pages/Forms/EditFormDetails/Components/SurveyJs/theme.css";
import QuestionDropPinModel from "./components/DropPin/model";
import SurveyDropPinQuestion, { dropPinProperties } from "./components/DropPin";
import {
  DrawPolygonState,
  DropPinState,
  GetGpsDataState,
  GpsCoordinatesState,
  PointPickerState,
  ShapePickerState,
} from "./stateConstructors";
import generateUniqueId from "./utils/generateUniqueId";
import apiLibrary from "services/api";
import { baseURL } from "config";
import axios from "axios";
import { camelCase, sentenceCase, snakeCase } from "change-case";
import { toggleSidebar } from "store/sideBar/reducer.actions";
import {
  fetchDataSources,
  getQuestionNamesFromAllPanels,
  handleOtherProperties,
  handleRequireAll,
  handleShowAll,
  initializePropertyVisibility,
  propertiesToBeHiddeFromPanels,
  registerPanels,
  updatePropertyVisibility,
} from "./utils/handlingOfDropDownsInHardCodeSections";
import { iconComponents } from "./iconNamesWithElement";
import {
  GENERAL_INFO_QUESTIONS_NAME,
  SAMPLE_QUESTIONS_NAME,
  SPECIES_DETAILS_QUESTIONS_NAME,
} from "./panelsQuestionsName";
import {
  IfetchSurveyJsFormDatails,
  IFormDetails,
} from "store/formDetailsSurveyJsFields/initialState";
import { TailSpin } from "react-loader-spinner";
import SurveyGetGpsDataQuestion, {
  getGpsDataProperties,
} from "./components/GetGpsData";
import QuestionGetGpsDataModel from "./components/GetGpsData/model";
import SurveyGpsCoordinatesQuestion, {
  gpsCoordinatesProperties,
} from "./components/GpsCoordinates";
import QuestionGpsCoordinatesModel from "./components/GpsCoordinates/model";
import { editorLocalization } from "survey-creator-core";
import { processExifData } from "view/pages/Observations/ObservationProfile";
import QuestionRegionPickerModel from "./components/RegionPicker/model";
import SurveyRegionPickerQuestion, {
  getRegionPickerProperties,
} from "./components/RegionPicker";

import SurveyPhoneNumberQuestion, {
  getPhoneNumberProperties,
} from "./components/PhoneNumber";

import useCustomBranding from "hooks/useCustomBranding";
import { alertTriggerIcon } from "./panels/alertTriggerIcon";
import { Toasts } from "view/components/Toasts";
import isValidUrl from "utils/isValidUrl";
import { SurveyModel } from "survey-core";
import {
  isSurveyDescriptionField,
  isSurveyTitleField,
  renderSurveyFormattedTextToHtml,
  shouldRenderSurveyFormattedText,
} from "./utils/renderSurveyFormattedTextToHtml";
import RichTextPropertyEditor from "./components/RichTextPropertyEditor";

// panels json for APIs
export let panelsJson: any = [];

export function updatePanelsJson(json: any) {
  return (panelsJson = json);
}

function attachFormatting(
  survey: SurveyModel & { __formattingAttached?: boolean },
) {
  if (!survey || survey.__formattingAttached) return;

  survey.__formattingAttached = true;
  survey.onTextMarkdown.add((_, options) => {
    if (!shouldRenderSurveyFormattedText(options.text, options.name)) return;

    options.html = renderSurveyFormattedTextToHtml(
      options.text,
      isSurveyDescriptionField(options.name) ? "block" : "inline",
    );
  });
}

let isRichTextEditorRegistered = false;

function registerRichTextEditorForPropertyGrid() {
  if (isRichTextEditorRegistered) return;
  isRichTextEditorRegistered = true;

  PropertyGridEditorCollection.register({
    fit(prop: any) {
      return (
        isSurveyTitleField(prop.name) || isSurveyDescriptionField(prop.name)
      );
    },
    getJSON() {
      return {
        type: "comment",
      };
    },
    onAfterRenderQuestion(obj: any, _prop: any, evtOptions: any) {
      const elementType = obj?.getType?.();
      const isSupportedElement =
        obj?.isQuestion ||
        elementType === "panel" ||
        elementType === "paneldynamic" ||
        elementType === "page";

      if (!isSupportedElement) return;

      const htmlElement = evtOptions?.htmlElement as HTMLElement | undefined;
      const editorQuestion = evtOptions?.question;
      if (!htmlElement || !editorQuestion) return;

      const contentElement =
        (htmlElement.querySelector(".sd-question__content") as HTMLElement) ||
        htmlElement;

      const defaultInput = contentElement.querySelector(
        "textarea, input",
      ) as HTMLElement | null;
      if (defaultInput) {
        defaultInput.style.display = "none";
      }

      let mountNode = contentElement.querySelector(
        ".isn-rich-text-editor-host",
      ) as HTMLElement | null;
      if (!mountNode) {
        mountNode = document.createElement("div");
        mountNode.className = "isn-rich-text-editor-host";
        contentElement.appendChild(mountNode);
      }

      const rootKey = "__isnRichTextRoot";
      let root = (mountNode as any)[rootKey];
      if (!root) {
        root = createRoot(mountNode);
        (mountNode as any)[rootKey] = root;
      }

      root.render(
        <RichTextPropertyEditor
          value={(editorQuestion.value as string) || ""}
          onChange={(nextValue) => {
            editorQuestion.value = nextValue;
          }}
        />,
      );
    },
  });
}

// Add or modify locales using dedicated API methods

// const hardCodePanels = registerPanels();
const propertiesToHide = propertiesToBeHiddeFromPanels();

export function registerCustomQuestionsAndPanels() {
  ElementFactory.Instance.registerElement(
    questionTypes.matrixdynamic,
    (name) => {
      const question = new QuestionMatrixDynamicModel(name);
      const defaultChoices = [1, 2, 3, 4, 5];
      const firstColumn = question.addColumn("Column 1") as any;
      firstColumn.cellType = "dropdown";
      firstColumn.choices = [...defaultChoices];
      const secondColumn = question.addColumn("Column 2") as any;
      secondColumn.cellType = "dropdown";
      secondColumn.choices = [...defaultChoices];
      question.rowCount = 1;
      question.minRowCount = 1;
      return question;
    },
  );

  // Register Custom Questions Models
  ElementFactory.Instance.registerElement(questionTypes.audio, (name) => {
    return new QuestionAudioModel(name);
  });

  ElementFactory.Instance.registerElement(questionTypes.geocoder, (name) => {
    return new QuestionGeoCoderModel(name);
  });
  ElementFactory.Instance.registerElement(questionTypes.shapePicker, (name) => {
    return new QuestionShapePickerModel(name);
  });
  ElementFactory.Instance.registerElement(questionTypes.pointPicker, (name) => {
    return new QuestionPointPickerModel(name);
  });

  ElementFactory.Instance.registerElement(questionTypes.phoneNumber, (name) => {
    return new QuestionPhoneNumberModel(name);
  });

  ElementFactory.Instance.registerElement(questionTypes.drawPolygon, (name) => {
    return new QuestionDrawPolygonModel(name);
  });
  ElementFactory.Instance.registerElement(questionTypes.dropPin, (name) => {
    return new QuestionDropPinModel(name);
  });
  ElementFactory.Instance.registerElement(questionTypes.getGpsData, (name) => {
    return new QuestionGetGpsDataModel(name);
  });
  ElementFactory.Instance.registerElement(
    questionTypes.gpsCoordinates,
    (name) => {
      return new QuestionGpsCoordinatesModel(name);
    },
  );

  // ✅ Register region picker question type correctly
  ElementFactory.Instance.registerElement(
    questionTypes.regionPicker,
    (name) => {
      return new QuestionRegionPickerModel(name);
    },
  );

  // Register Custom Questions Components
  ReactQuestionFactory.Instance.registerQuestion(
    questionTypes.audio,
    (props) => {
      return React.createElement(SurveyAudioQuestion, props);
    },
  );
  ReactQuestionFactory.Instance.registerQuestion(
    questionTypes.geocoder,
    (props) => {
      return React.createElement(SurveyGeoCoderQuestion, props);
    },
  );
  ReactQuestionFactory.Instance.registerQuestion(
    questionTypes.shapePicker,
    (props) => {
      return React.createElement(SurveyShapePickerQuestion, props);
    },
  );
  ReactQuestionFactory.Instance.registerQuestion(
    questionTypes.pointPicker,
    (props) => {
      return React.createElement(SurveyPointPickerQuestion, props);
    },
  );
  ReactQuestionFactory.Instance.registerQuestion(
    questionTypes.drawPolygon,
    (props) => {
      return React.createElement(SurveyDrawPolygonQuestion, props);
    },
  );
  ReactQuestionFactory.Instance.registerQuestion(
    questionTypes.dropPin,
    (props) => {
      return React.createElement(SurveyDropPinQuestion, props);
    },
  );

  ReactQuestionFactory.Instance.registerQuestion(
    questionTypes.getGpsData,
    (props) => {
      return React.createElement(SurveyGetGpsDataQuestion, props);
    },
  );
  ReactQuestionFactory.Instance.registerQuestion(
    questionTypes.gpsCoordinates,
    (props) => {
      return React.createElement(SurveyGpsCoordinatesQuestion, props);
    },
  );

  ReactQuestionFactory.Instance.registerQuestion(
    questionTypes.regionPicker,
    (props) => {
      return React.createElement(SurveyRegionPickerQuestion, props);
    },
  );

  ReactQuestionFactory.Instance.registerQuestion(
    questionTypes.phoneNumber,
    (props) => {
      return React.createElement(SurveyPhoneNumberQuestion, props);
    },
  );

  // Specify display names for the question type and its properties
  const locale = localization.getLocale("");
  locale.qt[questionTypes.audio] = "Audio";
  locale.qt[questionTypes.geocoder] = "Geocoder";
  locale.qt[questionTypes.shapePicker] = "Shape Picker";
  locale.qt[questionTypes.pointPicker] = "Point Picker";
  locale.qt[questionTypes.drawPolygon] = "Draw Polygon";
  locale.qt[questionTypes.dropPin] = "Drop A Pin";
  locale.qt[questionTypes.getGpsData] = "Get Gps Data";
  locale.qt[questionTypes.gpsCoordinates] = "Gps Coordinates";
  locale.qt[questionTypes.regionPicker] = "Region Picker";
  locale.qt[questionTypes.phoneNumber] = "Phone Number";
  // Register Questions Panels
  // ComponentCollection.Instance.add(riverConditionPanel(panelsJson));
  // ComponentCollection.Instance.add(gpsInfoPanel);
  // ComponentCollection.Instance.add(speciesDetailsPanel);
  // ComponentCollection.Instance.add(countDetailsPanel);
  // ComponentCollection.Instance.add(sightingDetailsPanel);
  // ComponentCollection.Instance.add(weatherConditionsPanel);
  // ComponentCollection.Instance.add(generalInfoPanel);
  // ComponentCollection.Instance.add(geographicalInfo);
  // ComponentCollection.Instance.add(harvest);
  // ComponentCollection.Instance.add(sample);
}

registerCustomQuestionsAndPanels();

export const panelNames = Object.values(panelsName);

export function unRegisterCustomQuestions() {
  ElementFactory.Instance.unregisterElement(questionTypes.geocoder);
  ElementFactory.Instance.unregisterElement(questionTypes.audio);
  ElementFactory.Instance.unregisterElement(questionTypes.shapePicker);
  ElementFactory.Instance.unregisterElement(questionTypes.pointPicker);
  ElementFactory.Instance.unregisterElement(questionTypes.drawPolygon);
  ElementFactory.Instance.unregisterElement(questionTypes.dropPin);
  ElementFactory.Instance.unregisterElement(questionTypes.getGpsData);
  ElementFactory.Instance.unregisterElement(questionTypes.regionPicker);
  ElementFactory.Instance.unregisterElement(questionTypes.phoneNumber);
  ElementFactory.Instance.unregisterElement(questionTypes.gpsCoordinates);
}

const panelQuestionNames = getQuestionNamesFromAllPanels();

export function applyingAndRemovingProperties() {
  // Register Properties of Custom Questions
  Serializer.addClass(
    questionTypes.audio,
    audioProperties,
    function () {
      return new QuestionAudioModel("");
    },
    "question",
  );
  Serializer.addClass(
    questionTypes.geocoder,
    geoCoderProperties,
    function () {
      return new QuestionGeoCoderModel("");
    },
    "question",
  );
  Serializer.addClass(
    questionTypes.shapePicker,
    shapePickerProperties,
    function () {
      return new QuestionShapePickerModel("");
    },
    "question",
  );
  Serializer.addClass(
    questionTypes.phoneNumber,
    getPhoneNumberProperties,
    function () {
      return new QuestionPhoneNumberModel("");
    },
    "question",
  );
  Serializer.addClass(
    questionTypes.pointPicker,
    pointPickerProperties,
    function () {
      return new QuestionPointPickerModel("");
    },
    "question",
  );
  Serializer.addClass(
    questionTypes.drawPolygon,
    drawPolygonProperties,
    function () {
      return new QuestionDrawPolygonModel("");
    },
    "question",
  );
  Serializer.addClass(
    questionTypes.dropPin,
    dropPinProperties,
    function () {
      return new QuestionDropPinModel("");
    },
    "question",
  );
  Serializer.addClass(
    questionTypes.getGpsData,
    getGpsDataProperties,
    function () {
      return new QuestionGetGpsDataModel("");
    },
    "question",
  );
  Serializer.addClass(
    questionTypes.gpsCoordinates,
    gpsCoordinatesProperties,
    function () {
      return new QuestionGpsCoordinatesModel("");
    },
    "question",
  );

  Serializer.addClass(
    questionTypes.regionPicker,
    getRegionPickerProperties,
    function () {
      return new QuestionRegionPickerModel("");
    },
    "question",
  );

  const addDynamicChoicesForQuestion = (questionType: string) => {
    const choicesType =
      questionType === "matrixdropdowncolumn"
        ? questionTypes.dropdown
        : questionType;

    Serializer.addProperty(questionType, {
      name: "serviceUrls:dropdown",
      displayName: "Services URL",
      choices: updateChoicesByUrl(choicesType),
      category: "choicesByUrl",
      onSetValue: async (sender, options) => {
        const newServiceUrls = options;
        const updatedChoices = await getDataFromSourceUrl(newServiceUrls);
        sender.choices = updatedChoices;
        sender.choicesByUrl.url = newServiceUrls;
        sender.choicesByUrl.titleName = "text";
        sender.choicesByUrl.valueName = "value";
        sender.choicesByUrl.attachData = true;
        sender.setPropertyValue(`dataSourceDetached`, false);
        sender.setPropertyValue("serviceUrls", newServiceUrls);
        sender.setPropertyValue(
          `dataSourceType`,
          extractDataSourceType(newServiceUrls),
        );
      },
    });
  };

  // Call the above method for different question types
  [
    questionTypes.tagbox,
    questionTypes.dropdown,
    questionTypes.radio,
    questionTypes.checkbox,
    "matrixdropdowncolumn",
  ].forEach((type) => addDynamicChoicesForQuestion(type));

  const matrixDropdownProperties =
    SurveyQuestionEditorDefinition.definition["matrixdropdowncolumn@dropdown"]
      ?.properties;
  if (
    matrixDropdownProperties &&
    !matrixDropdownProperties.some((property: any) =>
      typeof property === "string"
        ? property === "serviceUrls"
        : property.name === "serviceUrls",
    )
  ) {
    matrixDropdownProperties.push({
      name: "serviceUrls",
      tab: "choicesByUrl",
    });
  }

  Serializer.addProperty(questionTypes.phoneNumber, {
    name: "answer",
    category: "general",
    visibleIndex: 4,
    visible: false,
  });
  Serializer.getProperty("survey", "widthMode").defaultValue = "responsive";
  Serializer.getProperty("survey", "widthMode").visible = false;
  // Hide properties from questions
  questionsPropertiesToBeRemove.forEach((question: any) => {
    const { name, properties } = question;
    properties.forEach((property: string) => {
      if (Serializer.getProperty(name, property)) {
        Serializer.getProperty(name, property).visible = false;
      }
    });
  });

  panelNames.forEach((panelName: any) => {
    if (panelName !== panelsName.ALERT_TRIGGER) {
      Serializer.addProperty("panel", {
        name: `showAll${panelName}:boolean`,
        default: true,
        visible: false,
        visibleIndex: 4,
        displayName: "Show All",
        category: "general",
      });
    }
  });

  Serializer.addProperty("panel", {
    name: "_id",
    type: "text",
    category: "general",
    default: null,
    visible: false,
  });
  Serializer.addProperty("panel", {
    name: "panelType",
    type: "text",
    category: "general",
    default: null,
    visible: false,
  });

  const excludedNames = [
    "message",
    "admin_phone",
    "observer_phone",
    "observer_name",
  ];

  panelQuestionNames.forEach((element: any) => {
    if (!excludedNames.includes(element.name)) {
      Serializer.addProperty("panel", {
        name: `show${element.name}:boolean`,
        default: true,
        visible: false,
        displayName: element.title,
        category: "general",
      });
    }
  });

  // panelNames.forEach((panelName: any) => {
  //   if (panelName !== panelsName.ALERT_TRIGGER) {
  //     Serializer.addProperty("panel", {
  //       name: `requireAll${panelName}:boolean`,
  //       default: false,
  //       visible: false,
  //       displayName: "Require  All",
  //       category: "general",
  //     });
  //   }
  // });

  panelNames.forEach((panelName: any) => {
    if (panelName !== panelsName.ALERT_TRIGGER) {
      // Dynamically create CSS for this panelName
      const style = document.createElement("style");
      style.textContent = `
      .spg-question[data-name="showAll${panelName}"] .spg-checkbox__caption {
        font-weight: bold;
      }
      .spg-question[data-name="requireAll${panelName}"] {
        margin-top: 5px;
      }
      .spg-question[data-name="requireAll${panelName}"] .spg-checkbox__caption {
        font-weight: bold;
      }
    `;
      document.head.appendChild(style);

      // Add property with dynamic name
      Serializer.addProperty("panel", {
        name: `requireAll${panelName}:boolean`,
        default: false,
        visible: false,
        displayName: "Require All",
        category: "general",
      });
    }
  });

  // panelQuestionNames.forEach((element: any) => {
  //   Serializer.addProperty("panel", {
  //     name: `require${element.name}:boolean`,
  //     default: false,
  //     visible: false,
  //     displayName: element.title,
  //     category: "general",
  //   });
  // });

  panelQuestionNames.forEach((element: any) => {
    if (!excludedNames.includes(element.name)) {
      Serializer.addProperty("panel", {
        name: `require${element.name}`, // property key
        type: "boolean", // JS type
        default: false,
        visible: false,
        displayName: element.title,
        category: "general",
      });
    }
  });
}

addPropertyForRadioCheckBoxesTagboxAndDropdown();

export function resetAppliedAndReomvedProperties() {
  Serializer.removeClass(questionTypes.audio);
  Serializer.removeClass(questionTypes.geocoder);
  Serializer.removeClass(questionTypes.shapePicker);
  Serializer.removeClass(questionTypes.pointPicker);
  Serializer.removeClass(questionTypes.drawPolygon);
  Serializer.removeClass(questionTypes.dropPin);
  Serializer.removeClass(questionTypes.getGpsData);
  Serializer.removeClass(questionTypes.gpsCoordinates);

  Serializer.removeProperty(questionTypes.dropdown, "serviceUrls");
  Serializer.removeProperty(questionTypes.tagbox, "serviceUrls");
  Serializer.removeProperty(questionTypes.radio, "serviceUrls");
  Serializer.removeProperty(questionTypes.checkbox, "serviceUrls");
  Serializer.removeProperty(questionTypes.dropdown, "dataSourceDetached");
  Serializer.removeProperty(questionTypes.tagbox, "dataSourceDetached");
  Serializer.removeProperty(questionTypes.radio, "dataSourceDetached");
  Serializer.removeProperty(questionTypes.checkbox, "dataSourceDetached");

  Serializer.removeClass(questionTypes.regionPicker);
  Serializer.removeClass(questionTypes.phoneNumber);

  Serializer.getProperty("survey", "widthMode").visible = true;
  // reset properties from questions
  questionsPropertiesToBeRemove.forEach((question: any) => {
    const { name, properties } = question;
    properties.forEach((property: string) => {
      if (Serializer.getProperty(name, property)) {
        Serializer.getProperty(name, property).visible = true;
      }
    });
  });
}
export function unRegisterCustomPanels() {
  ComponentCollection.Instance.clear();
}

// Register SVG icon for the question type
SvgRegistry.registerIconFromSvg(questionTypes.audio, audioIcon);
SvgRegistry.registerIconFromSvg(questionTypes.geocoder, geoCoderIcon);
SvgRegistry.registerIconFromSvg(questionTypes.shapePicker, shapePickerIcon);
SvgRegistry.registerIconFromSvg(questionTypes.pointPicker, pointPickerIcon);
SvgRegistry.registerIconFromSvg(questionTypes.drawPolygon, drawPolygonIcon);
SvgRegistry.registerIconFromSvg(questionTypes.dropPin, dropPinIcon);
SvgRegistry.registerIconFromSvg(questionTypes.getGpsData, getGpsDataIcon);
SvgRegistry.registerIconFromSvg(
  questionTypes.gpsCoordinates,
  gpsCoordinatesIcon,
);

SvgRegistry.registerIconFromSvg(questionTypes.regionPicker, regionIcon);
SvgRegistry.registerIconFromSvg(questionTypes.phoneNumber, phoneNumberIcon);

SvgRegistry.registerIconFromSvg(panelsName.RIVER_CONDITION, riverIcon);
SvgRegistry.registerIconFromSvg(panelsName.GPS_INFORMATION, gpsIcon);
SvgRegistry.registerIconFromSvg(
  panelsName.GEOGRAPHICAL_INFORMATION,
  geographicalIcon,
);
SvgRegistry.registerIconFromSvg(panelsName.SPECIES_DETAIL, speciesDetailIcon);
SvgRegistry.registerIconFromSvg("harvest", harvestIcon);

SvgRegistry.registerIconFromSvg(panelsName.COUNT_DETAILS, countDetailsIcon);
SvgRegistry.registerIconFromSvg(panelsName.SIGHTING_DETAIL, sightingIcon);
SvgRegistry.registerIconFromSvg(panelsName.WEATHER_CONDITION, weatherIcon);
SvgRegistry.registerIconFromSvg(panelsName.GENERAL_INFORMATION, generalIcon);
SvgRegistry.registerIconFromSvg(panelsName.SAMPLE, sampleIcon);
SvgRegistry.registerIconFromSvg(
  panelsName.ENVIRONMENTAL_CONDITIONS,
  sampleIcon,
);
SvgRegistry.registerIconFromSvg(panelsName.ALERT_TRIGGER, alertTriggerIcon);

// Global Settings
function applyBackground(color: string) {
  setTimeout(() => {
    const surveyEl = document.getElementsByClassName(
      "sd-root-modern",
    )[0] as HTMLDivElement;
    if (surveyEl) {
      surveyEl.style.setProperty("--background", color);
    }
  }, 50);
}
function handleActiveTabChange(sender: any, options: any) {
  if (options.tabName === "test" || options.tabName === "designer") {
    applyBackground(sender.survey.backgroundColor);
  }
}

//A stop list of properties displayed in Layout,Validation and Data categories for different survey elements
const propertyStopList = [
  "state",
  "titleLocation",
  "descriptionLocation",
  "indent",
  "width",
  "minWidth",
  "maxWidth",
  "questionTitleLocation",
  "removePanelButtonLocation",
  "inputFieldSize",
  "rows",
  "autoGrow",
  "allowResize",
  "startWithNewLine",
  "hideNumber",
  //"colCount",
  "size",
  "questionsOrder",
  "innerIndent",
  "panelRemoveButtonLocation",
  "templateTitleLocation",
  "requiredErrorText",
  "validators",
  "maxLength",
  "keyName",
  "keyDuplicationError",
  "focusOnFirstError",
  "checkErrorsMode",
  "valuePropertyName",
];
const MAX_DYNAMIC_MATRIX_COLUMNS = 2;
const DYNAMIC_MATRIX_CELL_TYPES = ["dropdown", "text"];
const HIDDEN_DYNAMIC_MATRIX_COLUMN_PROPERTIES = new Set([
  "readOnly",
  "isUnique",
  "enableIf",
  "resetValueIf",
  "setValueIf",
  "setValueExpression",
  "maskType",
  "maskSettings",
  "totalType",
  "totalExpression",
  "totalFormat",
  "totalDisplayStyle",
  "totalAlignment",
  "totalCurrency",
  "totalMaximumFractionDigits",
  "totalMinimumFractionDigits",
]);

const isHiddenDynamicMatrixColumnProperty = (event: any) =>
  event.obj?.getType?.() === "matrixdropdowncolumn" &&
  event.obj?.colOwner?.getType?.() === questionTypes.matrixdynamic &&
  HIDDEN_DYNAMIC_MATRIX_COLUMN_PROPERTIES.has(event.property?.name);

function restrictDynamicMatrixCellTypes(creator: SurveyCreator) {
  creator.onPropertyEditorCreated.add((_, event) => {
    if (event.property.name !== "cellType") return;

    const editedObject = event.obj as any;
    const matrix =
      editedObject?.getType?.() === questionTypes.matrixdynamic
        ? editedObject
        : editedObject?.colOwner;
    if (matrix?.getType?.() !== questionTypes.matrixdynamic) return;

    (event.editor as any).choices = [
      { value: "dropdown", text: "Dropdown" },
      { value: "text", text: "Single-Line Input" },
    ];
  });

  creator.onShowingProperty.add((_, event: any) => {
    if (event.obj?.getType?.() !== "matrixdropdowncolumn") return;

    const matrix = event.obj.colOwner;
    if (matrix?.getType?.() !== questionTypes.matrixdynamic) return;

    if (isHiddenDynamicMatrixColumnProperty(event)) {
      event.showProperty = false;
      event.canShow = false;
      return;
    }

    if (event.property?.name !== "serviceUrls") return;

    const columnCellType = event.obj.cellType;
    const cellType =
      !columnCellType || columnCellType === "default"
        ? matrix?.cellType || questionTypes.dropdown
        : columnCellType;
    const canUseWebService =
      cellType === questionTypes.dropdown;

    event.showProperty = canUseWebService;
    event.canShow = canUseWebService;
  });
}

function limitDynamicMatrixColumns(json: any) {
  const visitElements = (elements: any[] = []) => {
    elements.forEach((element) => {
      if (element?.type === questionTypes.matrixdynamic) {
        const matrixCellType = DYNAMIC_MATRIX_CELL_TYPES.includes(
          element.cellType,
        )
          ? element.cellType
          : "dropdown";
        element.cellType = matrixCellType;
        element.columns = (element.columns ?? [])
          .slice(0, MAX_DYNAMIC_MATRIX_COLUMNS)
          .map((column: any) => ({
            ...column,
            cellType: DYNAMIC_MATRIX_CELL_TYPES.includes(column.cellType)
              ? column.cellType
              : matrixCellType,
          }));
      }

      visitElements(element?.elements);
      visitElements(element?.templateElements);
    });
  };

  (json?.pages ?? []).forEach((page: any) => visitElements(page?.elements));
  return json;
}

const options = {
  showLogicTab: true,
  showJSONEditorTab: false,
  showSurveyTitle: false,
  allowModifyPages: false,
  showNavigationButtons: false,
  showNavigationTabs: false,
  showNavigationPanel: false,
  showNavigationPanelTitle: false,
  showNavigationPanelButtons: false,
  showToolbar: true,
  allowChangeThemeInPreview: false,
  maximumColumnsCount: MAX_DYNAMIC_MATRIX_COLUMNS,
  // questionTypes: Object.values(questionTypes),
  questionTypes: Object.values(questionTypes).filter(
    (type) =>
      type !== questionTypes.gpsCoordinates &&
      type !== questionTypes.phoneNumber,
  ),
  showTitlesInExpressions: true,
};

// change the text message for empty survey
surveyLocalization.locales[surveyLocalization.defaultLocale]["emptySurvey"] =
  "Click one of the elements in the design interface to see its setting options";

surveyLocalization.locales[surveyLocalization.defaultLocale]["name"] =
  "Click one of the elements in the design interface to see its setting options";
// Assert the type of locales to any to bypass TypeScript checks
const editorLocales = editorLocalization.locales as any;

// Now you can modify the locales without TypeScript errors
editorLocales["en"] = {
  ...editorLocales["en"],
  pe: {
    name: "Custom Identifier",
    title: "Custom Title",
    description: "Custom Description",
  },
};
export const SurveyComponent = ({
  dataSourcesData,
  formDetails,
  doHide,
}: {
  dataSourcesData: any;
  formDetails: IFormDetails;
  doHide?: boolean;
}) => {
  const [creator, setCreator] = useState<SurveyCreator | null>(null);
  const { primaryColor } = useCustomBranding();
  const [isLoading, setIsLoading] = useState(false);
  // const [observers, setObservers] = useState<any[]>([]);
  // const [objects, setObjects] = useState<any[]>([]);
  // const [types, setTypes] = useState<any[]>([]);
  // const [categories, setCategories] = useState<any[]>([]);
  // const [species, setSpecies] = useState<any[]>([]);

  const dispatch: ThunkDispatch<any, any, AnyAction> = useDispatch();
  const [customSidebarContainer, setCustomSidebarContainer] = useState();
  const hardCodePanels = registerPanels(formDetails.programId);
  const translations = localization.getLocale("");
  translations.pehelp.question = {
    name: "The name you fill in here will be what gets displayed as column header in case you include this field in a report.",
  };

  if (SurveyQuestionEditorDefinition.definition["question"]?.properties) {
    const properties: any =
      SurveyQuestionEditorDefinition.definition["question"].properties;
    if (properties.name) {
      properties.name.title = "Custom Name";
    }
  }
  useEffect(() => {
    if (!creator) return;

    // Define categories (assuming this method is correct)
    creator.toolbox.defineCategories(
      [
        {
          category: "general",
          items: [panelsName.GEOGRAPHICAL_INFORMATION, panelsName.HARVEST],
        },
        {
          category: "complexElements",
          items: [
            questionTypes.shapePicker,
            questionTypes.pointPicker,
            questionTypes.drawPolygon,
            questionTypes.dropPin,
            questionTypes.geocoder,
            questionTypes.regionPicker,
          ],
        },
        {
          category: "readOnlyElements",
          items: [
            "text",
            "comment",
            "radiogroup",
            "checkbox",
            "dropdown",
            "tagbox",
            "boolean",
            "file",
            "imagepicker",
            "audio",
          ],
        },
        {
          category: "panels",
          items: [questionTypes.matrixdynamic, "panel", "paneldynamic"],
        },
      ],
      true,
    );
    creator.toolbox.removeItem(questionTypes.gpsCoordinates);
    creator.toolbox.removeItem(questionTypes.phoneNumber);
  }, [creator]);

  const mapQuestionCreators = [
    questionTypes.shapePicker,
    questionTypes.pointPicker,
    questionTypes.drawPolygon,
    questionTypes.dropPin,
    questionTypes.getGpsData,
    questionTypes.gpsCoordinates,
  ];

  const setTheChoicesOfDropdowns = (
    fieldName: any,
    dataSourcesData: {
      observers: any[];
      types: any[];
      objects: any[];
      categories: any[];
      species: any[];
    },
  ) => {
    switch (fieldName) {
      case SPECIES_DETAILS_QUESTIONS_NAME.Category:
        return dataSourcesData.categories;
      case SPECIES_DETAILS_QUESTIONS_NAME.SpecieName:
        return dataSourcesData.species;
      case SPECIES_DETAILS_QUESTIONS_NAME.Type:
        return dataSourcesData.types;
      case SPECIES_DETAILS_QUESTIONS_NAME.ObjectName:
        return dataSourcesData.objects;
      case SAMPLE_QUESTIONS_NAME.Sampler:
      case GENERAL_INFO_QUESTIONS_NAME.Observers:
      case GENERAL_INFO_QUESTIONS_NAME.DataEntry:
      case GENERAL_INFO_QUESTIONS_NAME.Reported:
        return dataSourcesData.observers;
      default:
        return [];
    }
  };

  let selectedQuestion: any = null;

  useEffect(() => {
    // dispatch(toggleSidebar(false));
    if (creator) return;
    registerRichTextEditorForPropertyGrid();

    // Serializer.getProperty(
    //   panelsName.GEOGRAPHICAL_INFORMATION,
    //   "description"
    // ).displayName = "Panel Description";
    // Serializer.getProperty(panelsName.HARVEST, "description").displayName =
    //   "Panel Description";

    const surveyCreator = new SurveyCreator(options);
    restrictDynamicMatrixCellTypes(surveyCreator);
    setCreator(surveyCreator);
  }, []);

  useEffect(() => {
    if (!creator) return;

    creator.getMarkdownHtml = (text: string, name?: string) =>
      shouldRenderSurveyFormattedText(text, name)
        ? renderSurveyFormattedTextToHtml(
            text,
            isSurveyDescriptionField(name) ? "block" : "inline",
          )
        : text;

    creator.onSurveyInstanceCreated.add((_, options) => {
      attachFormatting(
        options.survey as SurveyModel & { __formattingAttached?: boolean },
      );
    });

    attachFormatting(
      (creator as unknown as { survey?: SurveyModel }).survey as SurveyModel & {
        __formattingAttached?: boolean;
      },
    );
    attachFormatting(
      (creator as unknown as {
        simulator?: { survey?: SurveyModel };
      }).simulator?.survey as SurveyModel & {
        __formattingAttached?: boolean;
      },
    );
    attachFormatting(
      (creator as unknown as {
        designerPropertyGrid?: { survey?: SurveyModel };
      }).designerPropertyGrid?.survey as SurveyModel & {
        __formattingAttached?: boolean;
      },
    );

    applyingAndRemovingProperties();
    hardCodePanels.forEach((panel: any, index: number) => {
      if (
        panel.name === panelsName.RIVER_CONDITION ||
        panel.name === panelsName.WEATHER_CONDITION
      ) {
        return;
      }

      if (panel.name === panelsName.GPS_INFORMATION) {
        console.log("panel", panel);
      }

      creator.toolbox.addItem(
        {
          name: panel.name,
          isCopied: false,
          iconName: `icon-${panel.name}`,
          title: panel.title,
          json: panel,
          category: "general",
        } as any,
        index,
      );
    });

    Serializer.addProperty("panel", {
      name: "note:text", // Custom property to hold the note, non-editable
      isSerializable: false, // This ensures it doesn't affect the actual survey JSON
      readOnly: true,
      displayName:
        "Use the checkboxes below to show or hide questions. Hidden items stay visible in the builder—use the preview to verify concealment.",
      category: "general",
      visibleIndex: 4,
      visible: false,
    });
    // const toolboxItems = creator.toolbox.items;
  }, [creator]);

  useEffect(() => {
    if (!creator) return;
    // registering the custom sidebar
    !customSidebarContainer &&
      registerCustomPropertyGridSidebar(setCustomSidebarContainer);
    creator.onSelectedElementChanged.add((sender: any, options: any) => {
      try {
        selectedQuestion = options.newSelectedElement;

        if (options.newSelectedElement === null) {
          dispatch(updateSelectedQuestionEle(null));
        } else {
          dispatch(updateSelectedQuestionEle(options.newSelectedElement));
        }

        if (options.newSelectedElement !== null) {
          const doDisplayDefaultOptions = [
            panelsName.HARVEST,
            panelsName.GEOGRAPHICAL_INFORMATION,
          ].includes(options.newSelectedElement.name);

          handleDefaultAndCustomPropertyGridSidebars(
            options.newSelectedElement,
            doDisplayDefaultOptions,
          );
        }
      } finally {
        // Reset loader after React commits
        // requestAnimationFrame(() => {
        //   setIsLoading(false);
        // });
      }
    });

    // creator.onSelectedElementChanged.add((sender: any, options: any) => {
    //   selectedQuestion = options.newSelectedElement;
    //   if (options.newSelectedElement === null) {
    //     dispatch(updateSelectedQuestionEle(null));
    //   } else {
    //     dispatch(updateSelectedQuestionEle(options.newSelectedElement));
    //   }
    //   if (options.newSelectedElement !== null) {
    //     const doDisplayDefaultOptions = [
    //       panelsName.HARVEST,
    //       panelsName.GEOGRAPHICAL_INFORMATION,
    //     ].includes(options.newSelectedElement.name);

    //     handleDefaultAndCustomPropertyGridSidebars(
    //       options.newSelectedElement,
    //       doDisplayDefaultOptions
    //     );
    //   }
    //   // setTimeout(() => {
    //     requestAnimationFrame(() => {
    //       setIsLoading(false);
    //     });
    //   // }, 200);
    // });

    let isDeletionConfirmed = false;
    creator.onElementDeleting.add((sender: any, options: any) => {
      if (isDeletionConfirmed) {
        isDeletionConfirmed = false;
        return;
      }

      options.allowing = false;

      settings.confirmActionAsync("Are you sure?", (confirmed) => {
        if (!confirmed) {
          // setIsLoading(false); // ensure loader is cleared if canceled
          return;
        }

        // setIsLoading(true); // show loader immediately

        isDeletionConfirmed = true;
        const deletedElement = options.element;
        const eleType = deletedElement.getType();

        // small helper
        const makeRandomName = (prefix = "q") =>
          `${prefix}_${Math.random().toString(36).substring(2, 10)}`;

        // rename before deletion to avoid touching removed objects
        if (
          eleType === questionTypes.panel ||
          eleType === questionTypes.paneldynamic
        ) {
          for (const childQ of deletedElement?.elementsValue ?? []) {
            childQ.logicTitle = makeRandomName("panelItem");
            childQ.title = makeRandomName("panelItem");
            childQ.name = makeRandomName("panelItem");
          }
        } else {
          deletedElement.logicTitle = makeRandomName("panelItem");
          deletedElement.title = makeRandomName("panelItem");
          deletedElement.name = makeRandomName("q");
        }

        // now actually delete
        sender.deleteElement(deletedElement);

        // Redux updates
        if (mapQuestionCreators.includes(eleType)) {
          dispatch(updateDeletedQuestionEle(deletedElement));
        } else if (eleType === panelsName.HARVEST) {
          dispatch(updateAddedHarvestPanelMapQuestions({}));
        } else if (eleType === panelsName.GEOGRAPHICAL_INFORMATION) {
          dispatch(updateAddedGeographicalPanelMapQuestions({}));
        }

        // let React update UI, then hide loader
        // requestAnimationFrame(() => {
        //   setIsLoading(false);
        // });
      });
    });

    function handleDefaultAndCustomPropertyGridSidebars(
      element: any,
      doDisplayDefaultOptions: boolean,
    ) {
      const questionType = element?.isPanel
        ? element?.name
        : element?.getType();
      if (
        mapQuestionCreators.includes(questionType) ||
        questionType === panelsName.HARVEST ||
        questionType === panelsName.GEOGRAPHICAL_INFORMATION
      ) {
        // displaying custom sidebar
        toggleCustomPropertyGridSidebar(true);

        // hiding default sidebar
        togglePropertyGridSidebar(doDisplayDefaultOptions);
      } else {
        // hiding custom sidebar
        toggleCustomPropertyGridSidebar(false);
        // displaying default sidebar
        if (!doDisplayDefaultOptions) {
          togglePropertyGridSidebar(true);
        }
      }
    }
  }, [creator]);

  useEffect(() => {
    if (!creator) return;

    creator.onElementAllowOperations.add(function (_: any, options: any) {
      const questionType = options.obj?.getType();
      if (questionType === "panel") {
        options.allowChangeType = false;
        options.allowAddPanel = false;
        // options.allowCopy = false;
        options.allowChangeRequired = false;
      }

      if (mapQuestionCreators.includes(questionType)) {
        options.allowCopy = false;
        options.allowChangeRequired = false;
      }

      if (options.obj.isQuestion) {
        options.obj.logicTitle = options.obj.title;
      }

      if (
        options?.obj?.jsonObj?.type === panelsName.GEOGRAPHICAL_INFORMATION ||
        options?.obj?.jsonObj?.type === panelsName.HARVEST
      ) {
        options.allowEdit = false; // Disallow editing the panel itself
      }
    });
    // Prevending the duplication of panels and specific questions
    const panels = Object.values(panelsName);

    creator.onDesignerSurveyCreated.add(function (sender: any, options: any) {
      options.survey.showQuestionNumbers = "off";
    });
    creator.onShowingProperty.add(function (sender: any, options: any) {
      const questionName = options.obj?.jsonObj?.name;
      const propertyName = options.property?.name;
      if (
        options.obj?.isPanel &&
        questionName === panelsName.ALERT_TRIGGER &&
        propertyName === "note"
      ) {
        // Serializer.findProperty("panel", "note").visible = false;
      }
      setTimeout(() => {
        const notePropertyDomElement: HTMLElement | null =
          document.querySelector("div[data-name='note']");

        if (propertyName === "note" && notePropertyDomElement) {
          if (isTargetedQuestion(questionName)) {
            notePropertyDomElement.style.display = "none";
          } else {
            notePropertyDomElement.style.display = "block";

            const textField = notePropertyDomElement.querySelector("textarea");

            if (textField) {
              textField.style.display = "none";
            }
          }
        }
      }, 0);

      function isTargetedQuestion(name: string) {
        if (!Object.values(panelsName).includes(name)) {
          return true;
        }
        return false;
      }
    });

    // let isImageLinkUpdated = false;

    const isPredefinedImageLink = (url: string) =>
      url.startsWith("https://s3.us-west-2.amazonaws.com/isn-s3/isn");

    const processImageLink = async (
      updatedImageLink: string,
      targetQuestion: any,
      options: any,
    ) => {
      const choiceIndex = targetQuestion.jsonObj.choices.findIndex(
        (choice: any) => choice.value === options.target.id,
      );

      const skipUploadCondition = isPredefinedImageLink(updatedImageLink);

      // If predefined, directly update the choice
      if (skipUploadCondition) {
        if (choiceIndex !== -1) {
          handleChoiceUpdate(targetQuestion, choiceIndex, updatedImageLink);
        } else {
          targetQuestion.jsonObj.choices.push({
            imageLink: updatedImageLink,
            value: "",
          });
          updateChoices(targetQuestion, targetQuestion.jsonObj.choices);
        }
      } else {
        // Otherwise, upload the file and update the choice
        const { data: fileData } = await apiLibrary.file.uploadFileByUrl(
          "observations",
          "public",
          updatedImageLink,
        );

        const uploadedUrl = fileData?.path;
        if (uploadedUrl) {
          handleChoiceUpdate(targetQuestion, choiceIndex, uploadedUrl);
        }
      }
    };

    function findChangedImageLink(oldValue: any, newValue: any) {
      if (oldValue.length === 1 && newValue.length === 0) {
        return oldValue[0]?.toJSON()?.imageLink || null;
      }

      return oldValue
        .map((oldChoice: any, index: any) => {
          const oldImageLink = oldChoice.toJSON().imageLink;
          const newImageLink = newValue[index]?.toJSON()?.imageLink;
          return oldImageLink !== newImageLink ? oldImageLink : null;
        })
        .find((imageLink: any) => imageLink !== null);
    }

    // Re-entrancy guard. A counter handles nested internal updates safely.
    let internalUpdateDepth = 0;
    const beginInternal = () => {
      internalUpdateDepth++;
    };
    const endInternal = () => {
      internalUpdateDepth = Math.max(0, internalUpdateDepth - 1);
    };
    const isInternal = () => internalUpdateDepth > 0;

    let isImageLinkUpdated = false;

    const updateChoices = (targetQuestion: any, choices: any) => {
      beginInternal();
      try {
        targetQuestion.setPropertyValue("choices", choices);
      } finally {
        endInternal();
      }
    };

    const handleChoiceUpdate = (
      targetQuestion: any,
      choiceIndex: number,
      imageLink: string,
    ) => {
      if (choiceIndex !== -1) {
        targetQuestion.jsonObj.choices[choiceIndex].imageLink = imageLink;
        updateChoices(targetQuestion, targetQuestion.jsonObj.choices);
      }
    };

    const transformChoices = (element: any) => {
      if (element && Array.isArray(element.choices)) {
        element.choices = element.choices.map((choice: any) =>
          typeof choice === "string"
            ? { value: choice, imageLink: "" }
            : choice,
        );
      }
      return element;
    };

    creator.onModified.add(async (sender: any, options: any) => {
      // Skip any internally-triggered updates to prevent loops
      if (isInternal()) return;

      const questionsToModify = [
        questionTypes.checkbox,
        questionTypes.radio,
        questionTypes.dropdown,
        questionTypes.tagbox,
      ];

      if (options.type === "PROPERTY_CHANGED") {
        if (options.name === "imageLink" && options.newValue !== "") {
          if (isImageLinkUpdated) return;
          isImageLinkUpdated = true;

          try {
            setIsLoading(true);
            const updatedImageLink = options.newValue;
            if (!isValidUrl(updatedImageLink)) return;

            const oldImageLink = options.oldValue;

            if (
              oldImageLink &&
              isValidUrl(oldImageLink) &&
              isPredefinedImageLink(oldImageLink) &&
              !defaultImagePickerChoices.some(
                (item) => item.imageLink === oldImageLink,
              ) &&
              !formDetails.hasObservations
            ) {
              await apiLibrary.file.updateFileAttachmentStatus(oldImageLink);
            }

            // Any programmatic changes we do below should be wrapped
            beginInternal();
            try {
              await processImageLink(
                updatedImageLink,
                selectedQuestion,
                options,
              );
            } finally {
              endInternal();
            }
          } catch (error) {
            console.error("Error updating image link:", error);
          } finally {
            isImageLinkUpdated = false;
            setIsLoading(false);
          }
        }

        if (["choices", "text", "value"].includes(options.name)) {
          // Detach data source if needed (internal change)
          if (
            questionsToModify.includes(selectedQuestion.getType()) &&
            selectedQuestion.choicesByUrl &&
            selectedQuestion.choicesByUrl.url
          ) {
            beginInternal();
            try {
              selectedQuestion.choicesByUrl.url = "";
              selectedQuestion.setPropertyValue("dataSourceDetached", true);
              selectedQuestion.setPropertyValue("serviceUrls", "");
              selectedQuestion.setPropertyValue("dataSourceType", "");
            } finally {
              endInternal();
            }
          }

          if (
            options.name === "choices" &&
            options.target.getType() === questionTypes.imagepicker
          ) {
            const changedLink = findChangedImageLink(
              options.oldValue,
              options.newValue,
            );

            if (
              changedLink &&
              isValidUrl(changedLink) &&
              isPredefinedImageLink(changedLink) &&
              !defaultImagePickerChoices.some(
                (item) => item.imageLink === changedLink,
              ) &&
              !formDetails.hasObservations
            ) {
              await apiLibrary.file.updateFileAttachmentStatus(changedLink);
            }

            // Mutating jsonObj can fire change events — do it under guard
            beginInternal();
            try {
              options.target.jsonObj = transformChoices(
                options.target.toJSON(),
              );
            } finally {
              endInternal();
            }
          } else if (
            options.name === "value" &&
            selectedQuestion.getType() === questionTypes.imagepicker
          ) {
            beginInternal();
            try {
              selectedQuestion.jsonObj = selectedQuestion.toJSON();
            } finally {
              endInternal();
            }
          }
        }

        if (
          options.name === "defaultValue" &&
          selectedQuestion.parent?.isPanel &&
          selectedQuestion.parent.name === panelsName.ALERT_TRIGGER &&
          selectedQuestion.name === "message"
        ) {
          const current =
            selectedQuestion.getPropertyValue("defaultValue") || "";
          const newValue =
            current.length > 160 ? current.slice(0, 160) : current;
          if (newValue !== current) {
            beginInternal();
            try {
              selectedQuestion.setPropertyValue("defaultValue", newValue);
            } finally {
              endInternal();
            }
          }
        } else if (options.name === "title") {
          const questionType = options.target.getType();
          if (!mapQuestionCreators.includes(questionType)) {
            beginInternal();
            try {
              options.target.logicTitle = options.newValue;
            } finally {
              endInternal();
            }
          }
        }
      }
    });

    creator.onPropertyValidationCustomError.add((sender: any, options: any) => {
      if (options.propertyName === "name") {
        const element = options.obj;
        const elementType = element.getType();

        if (
          (elementType === "paneldynamic" || elementType === "panel") &&
          panels.includes(options.value)
        ) {
          options.error =
            "The name you entered is already in use for predefined panels. Please choose a different name.";
        }
      }

      // else if (options.propertyName === "title") {
      //   const element = options.obj;
      //   const elementType = element.getType();
      //   console.log(elementType);
      //   if (
      //     (elementType === "paneldynamic" || elementType === "panel") &&
      //     element.name === camelCase(options.value ?? "") &&
      //     panels.includes(camelCase(options.value ?? ""))
      //   ) {
      //     options.error =
      //       "The name you entered is already in use for predefined panels. Please choose a different name.";
      //   }
      // }
    });
    creator.onQuestionAdded.add((sender: any, options: any) => {
      const questionType = options.question.jsonObj?.type;

      if (panels.includes(questionType)) {
        // getting the counting of added panel in questions array
        const questionExistenceCountArr = JSON.stringify(creator.JSON).match(
          new RegExp(questionType, "g"),
        ) as any[];

        const isPanelDuplicate = questionExistenceCountArr?.length > 1;

        if (isPanelDuplicate) {
          let updatedJSON = creator.JSON;

          // finding currently added panel index
          const addedPanelIndex = updatedJSON.pages[0]?.elements?.findLastIndex(
            (e: any) => e?.type === questionType,
          );

          if (addedPanelIndex >= 0) {
            // removing the added panel because it is duplication
            const updatedQuestionElements =
              updatedJSON.pages[0]?.elements?.filter(
                (e: any, index: number) => index !== addedPanelIndex,
              );

            updatedJSON.pages[0].elements = updatedQuestionElements;

            // replacing the main json with updated json
            creator.JSON = updatedJSON;
          }
        }
      }
      // handle map type components
      if (mapQuestionCreators.includes(questionType)) {
        // initializeQuestionState(options.question,dispatch)
        let questionInstance;
        switch (questionType) {
          case questionTypes.shapePicker:
            const shapePickerInstance = new ShapePickerState();
            questionInstance = shapePickerInstance;

            break;

          case questionTypes.pointPicker:
            const pointPickerInstance = new PointPickerState();
            questionInstance = pointPickerInstance;

            break;

          case questionTypes.drawPolygon:
            const drawPolygonInstance = new DrawPolygonState();
            questionInstance = drawPolygonInstance;

            break;

          case questionTypes.dropPin:
            const dropPinInstance = new DropPinState();
            questionInstance = dropPinInstance;

            break;

          case questionTypes.getGpsData:
            const getGpsDataInstance = new GetGpsDataState();
            questionInstance = getGpsDataInstance;

            break;
          case questionTypes.gpsCoordinates:
            const gpsCoordinatesInstance = new GpsCoordinatesState();
            questionInstance = gpsCoordinatesInstance;

            break;
        }

        if (questionInstance) {
          dispatch(updateAddedQuestionState(questionInstance));
          options.question._id = questionInstance.id;
          options.question.rdx_id = questionInstance.id;
          if (questionType === questionTypes.gpsCoordinates) {
            options.question.isRequired = true;
          }
        }
      }

      // handle map type components in panels
      if (questionType === panelsName.HARVEST) {
        const retrievalShapePicker = new ShapePickerState({
          mapCenterPoint: {
            longitude: -145.6433003,
            latitude: 65.0710178,
          },
        });
        const struckShapePicker = new ShapePickerState({
          mapCenterPoint: {
            longitude: -145.6433003,
            latitude: 65.0710178,
          },
        });
        const retrievalPointPicker = new PointPickerState({
          mapCenterPoint: {
            longitude: -145.6433003,
            latitude: 65.0710178,
          },
        });
        const struckPointPicker = new PointPickerState({
          mapCenterPoint: {
            longitude: -145.6433003,
            latitude: 65.0710178,
          },
        });

        const harvest = {
          id: generateUniqueId("harvest#"),
          retrievalShapePicker,
          struckShapePicker,
          retrievalPointPicker,
          struckPointPicker,
        };

        options.question._id = harvest.id;
        dispatch(updateAddedHarvestPanelMapQuestions(harvest));
      } else if (questionType === panelsName.GEOGRAPHICAL_INFORMATION) {
        const regionTypeShapePicker = new ShapePickerState({
          mapCenterPoint: {
            longitude: -145.6433003,
            latitude: 65.0710178,
          },
        });
        const viewTypeShapePicker = new ShapePickerState({
          mapCenterPoint: {
            longitude: -145.6433003,
            latitude: 65.0710178,
          },
        });
        const pointPicker = new PointPickerState({
          mapCenterPoint: {
            longitude: -145.6433003,
            latitude: 65.0710178,
          },
        });

        const geographical = {
          id: generateUniqueId("geographical#"),
          regionTypeShapePicker,
          viewTypeShapePicker,
          pointPicker,
        };

        options.question._id = geographical.id;

        dispatch(updateAddedGeographicalPanelMapQuestions(geographical));
      }
      if (
        options.question.isQuestion &&
        options.question.getType() === questionTypes.imagepicker
      ) {
        options.question.setPropertyValue("choices", defaultImagePickerChoices);
        options.question.jsonObj.choices = defaultImagePickerChoices;
      }
      if (options.question.isQuestion) {
        options.question.logicTitle = options.question.title;
      }
    });
    creator.onModified.add((sender: any, options: any) => {
      if (options.type === "QUESTION_CONVERTED") {
        const questionType = options.newValue.getType();

        if (panels.includes(questionType)) {
          // getting the counting of added panel in questions array
          const questionExistenceCountArr = JSON.stringify(creator.JSON).match(
            new RegExp(questionType, "g"),
          ) as any[];

          const isPanelDuplicate = questionExistenceCountArr?.length > 1;

          if (isPanelDuplicate) {
            let updatedJSON = creator.JSON;

            // finding currently added panel index
            const addedPanelIndex =
              updatedJSON.pages[0]?.elements?.findLastIndex(
                (e: any) => e?.type === questionType,
              );

            if (addedPanelIndex >= 0) {
              // removing the added panel because it is duplication
              const updatedQuestionElements =
                updatedJSON.pages[0]?.elements?.filter(
                  (e: any, index: number) => index !== addedPanelIndex,
                );

              updatedJSON.pages[0].elements = updatedQuestionElements;

              // replacing the main json with updated json
              creator.JSON = updatedJSON;
            }
          }
        }
        // handle map type components
        if (mapQuestionCreators.includes(questionType)) {
          // initializeQuestionState(options.question,dispatch)
          let questionInstance;
          switch (questionType) {
            case questionTypes.shapePicker:
              const shapePickerInstance = new ShapePickerState();
              questionInstance = shapePickerInstance;

              break;

            case questionTypes.pointPicker:
              const pointPickerInstance = new PointPickerState();
              questionInstance = pointPickerInstance;

              break;

            case questionTypes.drawPolygon:
              const drawPolygonInstance = new DrawPolygonState();
              questionInstance = drawPolygonInstance;

              break;

            case questionTypes.dropPin:
              const dropPinInstance = new DropPinState();
              questionInstance = dropPinInstance;

              break;

            case questionTypes.getGpsData:
              const getGpsDataInstance = new GetGpsDataState();
              questionInstance = getGpsDataInstance;

              break;
            case questionTypes.gpsCoordinates:
              const gpsCoordinatesInstance = new GpsCoordinatesState();
              questionInstance = gpsCoordinatesInstance;

              break;
          }

          if (questionInstance) {
            dispatch(updateAddedQuestionState(questionInstance));
            options.newValue._id = questionInstance.id;
            options.newValue.rdx_id = questionInstance.id;
            if (questionType === questionTypes.gpsCoordinates) {
              options.newValue.isRequired = true;
            }
          }
        }
        // handle map type components in panels
        if (questionType === panelsName.HARVEST) {
          const retrievalShapePicker = new ShapePickerState({
            mapCenterPoint: {
              longitude: -145.6433003,
              latitude: 65.0710178,
            },
          });
          const struckShapePicker = new ShapePickerState({
            mapCenterPoint: {
              longitude: -145.6433003,
              latitude: 65.0710178,
            },
          });
          const retrievalPointPicker = new PointPickerState({
            mapCenterPoint: {
              longitude: -145.6433003,
              latitude: 65.0710178,
            },
          });
          const struckPointPicker = new PointPickerState({
            mapCenterPoint: {
              longitude: -145.6433003,
              latitude: 65.0710178,
            },
          });

          const harvest = {
            id: generateUniqueId("harvest#"),
            retrievalShapePicker,
            struckShapePicker,
            retrievalPointPicker,
            struckPointPicker,
          };

          options.newValue._id = harvest.id;
          dispatch(updateAddedHarvestPanelMapQuestions(harvest));
        } else if (questionType === panelsName.GEOGRAPHICAL_INFORMATION) {
          const regionTypeShapePicker = new ShapePickerState({
            mapCenterPoint: {
              longitude: -145.6433003,
              latitude: 65.0710178,
            },
          });
          const viewTypeShapePicker = new ShapePickerState({
            mapCenterPoint: {
              longitude: -145.6433003,
              latitude: 65.0710178,
            },
          });
          const pointPicker = new PointPickerState({
            mapCenterPoint: {
              longitude: -145.6433003,
              latitude: 65.0710178,
            },
          });

          const geographical = {
            id: generateUniqueId("geographical#"),
            regionTypeShapePicker,
            viewTypeShapePicker,
            pointPicker,
          };

          options.newValue._id = geographical.id;

          dispatch(updateAddedGeographicalPanelMapQuestions(geographical));
        }
      }
    });
    // Remove custom panels and questions from dynamic panel change type selector
    creator.onDefineElementMenuItems.add((_: any, options: any) => {
      const parentQuestion = options.obj.parent?.getType();

      if (
        parentQuestion === questionTypes.paneldynamic ||
        parentQuestion === questionTypes.panel
      ) {
        const converToAction: any = options.items.find(
          (item: any) => item.innerItem.id === "convertTo",
        );
        // edit questions list of element selecotrs
        try {
          if (converToAction) {
            const newActions =
              converToAction.innerItem.popupModel.propertyHash.contentComponentData.model.propertyHash.actions.filter(
                (action: any) => {
                  if (
                    action.id !== questionTypes.paneldynamic &&
                    !panels.includes(action.id) &&
                    action.id !== questionTypes.panel
                  ) {
                    return true;
                  }
                  return false;
                },
              );

            converToAction.innerItem.popupModel.propertyHash.contentComponentData.model.propertyHash.actions =
              newActions;
          }
        } catch {}
      }
    });

    // stop addition of some questions element into panels or dynamic panel through drag and drop system
    creator.onDragDropAllow.add((sender: any, options: any) => {
      const source = options.source?.getType();
      const target = options.target?.getType();
      const targetParent = options.target.parent?.getType();

      if (
        [questionTypes.panel, questionTypes.paneldynamic].includes(source) &&
        [questionTypes.panel, questionTypes.paneldynamic].includes(targetParent)
      ) {
        options.allow = false;
      }

      let updatedJSON = creator.JSON;
      const panelType = options.target?.parent?.jsonObj?.panelType;

      if (
        panelType === "static" ||
        panelNames.includes(options.target?.parent?.jsonObj?.name)
      ) {
        options.allow = false;
      }

      if (options.draggedElement.toolboxItemIconName === undefined) {
        return;
      }

      const panelName = options?.draggedElement?.toolboxItemIconName?.replace(
        "icon-",
        "",
      );

      const panelInstances = updatedJSON?.pages?.flatMap((page: any) =>
        page.elements.filter(
          (e: any) => e.type === "panel" && e.name === panelName,
        ),
      );

      if (
        panelNames.includes(options.target?.parent?.name) ||
        panelInstances?.length > 0
      ) {
        options.allow = false;
      }

      const questionsStopToAdded = [
        questionTypes.paneldynamic,
        questionTypes.panel,
        ...Object.values(panelsName),
      ];

      if (
        questionsStopToAdded.includes(source) &&
        ([questionTypes.paneldynamic, questionTypes.panel].includes(target) ||
          [questionTypes.paneldynamic, questionTypes.panel].includes(
            targetParent,
          ))
      ) {
        options.allow = false;
      }
    });

    // handle upload file via survey js
    creator.onUploadFile.add(async (_: any, options: any) => {
      try {
        // Upload the file and get its data
        const { data: fileData } = await apiLibrary.file.fileUpload(
          options.files[0],
          false,
          "public",
        );

        const videoExtensions: string[] = [
          "mp4",
          "webm",
          "ogg",
          "avi",
          "mov",
          "mkv",
          "flv",
          "wmv",
          "3gp",
          "mpeg",
          "ts",
          "divx",
          "xvid",
        ];

        const isVideoType = (type: string) =>
          videoExtensions.includes(type?.toLowerCase());
        if (!isVideoType(fileData.type)) {
          // Load EXIF tags from the uploaded file
          const loadedTags = await ExifReader.load(options.files[0], {
            async: true,
          });

          const processedExifData = processExifData(loadedTags);

          // Post the processed EXIF data using the file's id
          await apiLibrary.Observations.postExifData(
            fileData.id,
            processedExifData,
          );
        }

        // Return success with the file URL and appended file id
        options.callback(
          "success",
          `${fileData.file.original}?fileId=${fileData.id}`,
        );
      } catch (error: any) {
        console.log("Error uploading file:", error);
        options.callback("error");
      }
    });

    creator.onDragEnd.add((sender: any, options: any) => {
      if (options.fromElement?.getType() !== "page") {
        const questionType = options.draggedElement.jsonObj?.type;

        // if (panels.includes(questionType)) {
        //   // getting the counting of added panel in questions array
        //   const questionExistenceCountArr = JSON.stringify(creator.JSON).match(
        //     new RegExp(questionType, "g")
        //   ) as any[];

        //   const isPanelDuplicate = questionExistenceCountArr?.length > 1;

        //   if (isPanelDuplicate) {
        //     let updatedJSON = creator.JSON;

        //     // finding currently added panel index
        //     const addedPanelIndex =
        //       updatedJSON.pages[0]?.elements?.findLastIndex(
        //         (e: any) => e?.type === questionType
        //       );

        //     if (addedPanelIndex >= 0) {
        //       // removing the added panel because it is duplication
        //       const updatedQuestionElements =
        //         updatedJSON.pages[0]?.elements?.filter(
        //           (e: any, index: number) => index !== addedPanelIndex
        //         );

        //       updatedJSON.pages[0].elements = updatedQuestionElements;

        //       // replacing the main json with updated json
        //       creator.JSON = updatedJSON;
        //     }
        //   }
        // }
        // handle map type components
        if (mapQuestionCreators.includes(questionType)) {
          // initializeQuestionState(options.question,dispatch)
          let questionInstance;
          switch (questionType) {
            case questionTypes.shapePicker:
              const shapePickerInstance = new ShapePickerState();
              questionInstance = shapePickerInstance;

              break;

            case questionTypes.pointPicker:
              const pointPickerInstance = new PointPickerState();
              questionInstance = pointPickerInstance;

              break;

            case questionTypes.drawPolygon:
              const drawPolygonInstance = new DrawPolygonState();
              questionInstance = drawPolygonInstance;

              break;

            case questionTypes.dropPin:
              const dropPinInstance = new DropPinState();
              questionInstance = dropPinInstance;

              break;

            case questionTypes.getGpsData:
              const getGpsDataInstance = new GetGpsDataState();
              questionInstance = getGpsDataInstance;

              break;
            case questionTypes.gpsCoordinates:
              const gpsCoordinatesInstance = new GpsCoordinatesState();
              questionInstance = gpsCoordinatesInstance;

              break;
          }

          if (questionInstance) {
            dispatch(updateAddedQuestionState(questionInstance));
            options.draggedElement._id = questionInstance.id;
            options.draggedElement.rdx_id = questionInstance.id;
            if (questionType === questionTypes.gpsCoordinates) {
              options.draggedElement.isRequired = true;
            }
          }
        }
        // handle map type components in panels
        if (questionType === panelsName.HARVEST) {
          const retrievalShapePicker = new ShapePickerState({
            mapCenterPoint: {
              longitude: -145.6433003,
              latitude: 65.0710178,
            },
          });
          const struckShapePicker = new ShapePickerState({
            mapCenterPoint: {
              longitude: -145.6433003,
              latitude: 65.0710178,
            },
          });
          const retrievalPointPicker = new PointPickerState({
            mapCenterPoint: {
              longitude: -145.6433003,
              latitude: 65.0710178,
            },
          });
          const struckPointPicker = new PointPickerState({
            mapCenterPoint: {
              longitude: -145.6433003,
              latitude: 65.0710178,
            },
          });
          const harvest = {
            id: generateUniqueId("harvest#"),
            retrievalShapePicker,
            struckShapePicker,
            retrievalPointPicker,
            struckPointPicker,
          };

          options.draggedElement._id = harvest.id;
          dispatch(updateAddedHarvestPanelMapQuestions(harvest));
        } else if (questionType === panelsName.GEOGRAPHICAL_INFORMATION) {
          const regionTypeShapePicker = new ShapePickerState({
            mapCenterPoint: {
              longitude: -145.6433003,
              latitude: 65.0710178,
            },
          });
          const viewTypeShapePicker = new ShapePickerState({
            mapCenterPoint: {
              longitude: -145.6433003,
              latitude: 65.0710178,
            },
          });
          const pointPicker = new PointPickerState({
            mapCenterPoint: {
              longitude: -145.6433003,
              latitude: 65.0710178,
            },
          });
          const geographical = {
            id: generateUniqueId("geographical#"),
            regionTypeShapePicker,
            viewTypeShapePicker,
            pointPicker,
          };

          options.draggedElement._id = geographical.id;

          dispatch(updateAddedGeographicalPanelMapQuestions(geographical));
        }
      }
    });
  }, [creator]);

  useEffect(() => {
    if (!creator) return;
    creator.onPanelAdded.add((sender: any, options: any) => {
      // Show loader immediately, but don’t block React with flushSync
      // setIsLoading(true);

      // Wait for the next frame so the spinner actually paints
      // requestAnimationFrame(() => {
      try {
        let panel = options.panel;

        if (panel.jsonObj && !panelNames.includes(panel.jsonObj.name)) {
          const panelName = options.panel.toolboxItemIconName?.replace(
            "icon-",
            "",
          );

          if (panelNames.includes(panelName)) {
            panel.jsonObj.name = panelName;
            options.panel = panel;
            panel.name = panelName;

            const panelJson = hardCodePanels.find(
              (panel: any) => panel.name === panelName,
            );

            options.panel.elements.forEach((question: any, index: number) => {
              question.name = panelJson?.elements[index]?.name;
              question.jsonObj = panelJson?.elements[index];
            });
          }
        }

        if (panel.jsonObj && panelNames.includes(panel.jsonObj.name)) {
          panel.name = panel.jsonObj.name;
          options.panel.setPropertyValue("panelType", "static");

          panel?.elements?.forEach((question: any) => {
            question.name = question.jsonObj.name;

            if (
              (question.getType() === questionTypes.tagbox ||
                question.getType() === questionTypes.dropdown) &&
              question.choicesByUrl &&
              question.choicesByUrl.url
            ) {
              question.choices = setTheChoicesOfDropdowns(
                question.jsonObj.name,
                dataSourcesData,
              );
              question.jsonObj.choices = setTheChoicesOfDropdowns(
                question.jsonObj.name,
                dataSourcesData,
              );
            }
          });

          if (panel.jsonObj.name === panelsName.HARVEST) {
            const retrievalShapePicker = new ShapePickerState({
              mapCenterPoint: {
                longitude: -145.6433003,
                latitude: 65.0710178,
              },
            });
            const struckShapePicker = new ShapePickerState({
              mapCenterPoint: {
                longitude: -145.6433003,
                latitude: 65.0710178,
              },
            });
            const retrievalPointPicker = new PointPickerState({
              mapCenterPoint: {
                longitude: -145.6433003,
                latitude: 65.0710178,
              },
            });
            const struckPointPicker = new PointPickerState({
              mapCenterPoint: {
                longitude: -145.6433003,
                latitude: 65.0710178,
              },
            });

            const harvest = {
              id: generateUniqueId("harvest#"),
              retrievalShapePicker,
              struckShapePicker,
              retrievalPointPicker,
              struckPointPicker,
            };

            options.panel._id = harvest.id;
            options.panel.setPropertyValue("_id", harvest.id);
            dispatch(updateAddedHarvestPanelMapQuestions(harvest));
          } else if (
            panel.jsonObj.name === panelsName.GEOGRAPHICAL_INFORMATION
          ) {
            const regionTypeShapePicker = new ShapePickerState({
              mapCenterPoint: {
                longitude: -145.6433003,
                latitude: 65.0710178,
              },
            });
            const viewTypeShapePicker = new ShapePickerState({
              mapCenterPoint: {
                longitude: -145.6433003,
                latitude: 65.0710178,
              },
            });
            const pointPicker = new PointPickerState({
              mapCenterPoint: {
                longitude: -145.6433003,
                latitude: 65.0710178,
              },
            });

            const geographical = {
              id: generateUniqueId("geographical#"),
              regionTypeShapePicker,
              viewTypeShapePicker,
              pointPicker,
            };

            options.panel._id = geographical.id;
            options.panel.setPropertyValue("_id", geographical.id);
            dispatch(updateAddedGeographicalPanelMapQuestions(geographical));
          }

          let updatedJSON = creator.JSON;

          const panelInstances = updatedJSON?.pages?.flatMap((page: any) =>
            page.elements.filter(
              (e: any) => e.type === "panel" && e.name === panel.name,
            ),
          );

          if (
            panelInstances?.length > 1 &&
            panel.name === panelsName.ALERT_TRIGGER
          ) {
            Toasts.error("Only one Alert Trigger can be added per form");
          }

          if (panelInstances?.length > 1) {
            const addedPanelIndex = updatedJSON.pages.findIndex((page: any) =>
              page.elements.some((e: any) => e.name === panel.name),
            );

            if (addedPanelIndex >= 0) {
              updatedJSON.pages[0].elements =
                updatedJSON.pages[0].elements.filter(
                  (element: any, index: any, array: any[]) =>
                    array.findIndex((ele: any) => ele.name === element.name) ===
                    index,
                );

              creator.JSON = updatedJSON;
            }
          }
        }
      } finally {
        // Always stop loader, even if error happens
        // requestAnimationFrame(() => setIsLoading(false));
      }
      // });
    });

    creator.onShowingProperty.add(function (sender: any, options: any) {
      if (!options.property.name && !options?.obj?.toJSON()?.name) return;

      if (
        propertiesToHide.includes(options.property.name) &&
        panelNames.includes(options.obj.toJSON().name)
      ) {
        options.showProperty =
          options.property.name === "visibleIf" &&
          panelsName.ALERT_TRIGGER === options.obj.toJSON().name;
        options.canShow =
          options.property.name === "visibleIf" &&
          panelsName.ALERT_TRIGGER === options.obj.toJSON().name;
        if (
          panelsName.ALERT_TRIGGER === options.obj.toJSON().name &&
          options.property.name === "note"
        ) {
          options.showProperty = false;
          options.canShow = false;
        }
      }
      // if (options.obj.parent && options.obj.parent.getType() === "panel") {
      //   if (panelNames.includes(options.obj.parent.name)) {
      //     if (
      //       (options.obj.isQuestion && options.obj.getType() !== "dropdown") ||
      //       (options.obj.getType() === "dropdown" &&
      //         options.property.name !== "choices")
      //     ) {
      //       options.showProperty = false;
      //       options.canShow = false;
      //     }
      //   }
      // }
    });

    creator.onElementAllowOperations.add(function (sender: any, options: any) {
      if (panelNames.includes(options.obj.jsonObj?.name)) {
        options.allowChangeType = false;
        // options.allowAddPanel = false;
        options.allowCopy = false;
        // options.allowChangeRequired = false;
        options.allowChangeTitle = false;
        options.allowEdit = false;
        options.allowShowPanel = false;
        options.allowHidePanel = false;
        options.allowChangePageTitle = false;
        options.allowChangePageDescription = false;
        // options.allowChangeDescription = false;
        // options.allowDragging = false;
        // options.allowChangeInputType = false;
        // options.allowShowSettings = false;
        // options.allowSelection = false;
      }

      if (
        options.obj.isQuestion &&
        panelNames.includes(options.obj.parent?.jsonObj?.name)
      ) {
        options.allowChangeType = false;
        options.allowAddPanel = false;
        options.allowCopy = false;
        options.allowChangeRequired = false;
        options.allowChangeTitle = false;
        options.allowDelete = false;
        options.allowEdit = false;
        // options.allowShowPanel = false;
        options.allowHidePanel = false;
        options.allowChangePageTitle = false;
        options.allowChangePageDescription = false;
        options.allowChangeDescription = false;
        options.allowDragging = false;
        options.allowChangeInputType = false;
        options.allowShowSettings = false;
        options.allowSelection = false;
      }
    });

    let lastSelectedDropdownWithinCustomPanel: any = null;

    creator.onSelectedElementChanging.add((sender: any, options: any) => {
      try {
        const newSelectedElement = options.newSelectedElement;
        const parent = newSelectedElement?.parent;
        const isPanel = parent?.isPanel;
        const parentNameIncluded = panelNames.includes(parent?.name);
        const questionType = newSelectedElement?.getType();

        const isQuestionTypeExist = [
          questionTypes.checkbox,
          questionTypes.dropdown,
          questionTypes.tagbox,
          questionTypes.radio,
          questionTypes.phoneNumber,
          questionTypes.gpsCoordinates,
        ].includes(questionType);
        // Helper function to find and update "note" property visibility
        const updateNoteVisibility = (
          questionType: any,
          visibility: boolean,
        ) => {
          if (questionType !== questionTypes.panel) return;
          const noteProperty = Serializer.findProperty(questionType, "note");
          if (noteProperty) {
            noteProperty.visible = visibility;
          }
        };

        // Panel-specific logic
        if ([questionTypes.panel].includes(questionType)) {
          Serializer.findProperty(questionType, "name").displayName =
            "Panel Name";
          translations.pehelp = translations.pehelp || {};
          translations.pehelp.panel = translations.pehelp.panel || {};

          if (newSelectedElement.name === panelsName.ALERT_TRIGGER) {
            Serializer.findProperty(questionType, "visibleIf").displayName =
              "Trigger Alert if";
            translations.pehelp.panel.visibleIf =
              "Use the magic wand icon to set a conditional rule that determines the alert trigger.";

            updateNoteVisibility(questionType, false);
          } else {
            Serializer.findProperty(questionType, "visibleIf").displayName =
              "Make the panel visible if";
            translations.pehelp.panel.visibleIf =
              "Use the magic wand icon to set a conditional rule that determines panel visibility.";
          }
        } else if (
          [questionTypes.paneldynamic, questionTypes.panel].includes(
            questionType,
          )
        ) {
          Serializer.findProperty(questionType, "name").displayName =
            "Panel Name";
        } else {
          Serializer.findProperty("question", "name").displayName =
            "Column Name";
        }

        // Handle panel visibility and "note" property
        if (
          newSelectedElement &&
          newSelectedElement.isPanel &&
          panelNames.includes(newSelectedElement.name)
        ) {
          updateNoteVisibility(questionType, true);
        } else {
          updateNoteVisibility(questionType, false);
        }

        const isMapQuestion = [
          questionTypes.shapePicker,
          questionTypes.pointPicker,
          questionTypes.drawPolygon,
          questionTypes.dropPin,
          questionTypes.getGpsData,
          // questionTypes.gpsCoordinates,
        ].includes(questionType);

        // Handle element selection changes
        if (
          newSelectedElement &&
          isPanel &&
          parentNameIncluded &&
          isMapQuestion
        ) {
          options.newSelectedElement = parent;
        } else if (
          newSelectedElement &&
          isPanel &&
          parentNameIncluded &&
          !isQuestionTypeExist &&
          ![questionTypes.text, questionTypes.boolean].includes(questionType)
        ) {
          options.newSelectedElement = lastSelectedDropdownWithinCustomPanel;
        }

        // else if (
        //   [questionTypes.text, questionTypes.boolean].includes(questionType)
        // ) {
        //   lastSelectedDropdownWithinCustomPanel = null;
        // }

        // Initialize property visibility
        initializePropertyVisibility(
          newSelectedElement,
          newSelectedElement?.toJSON(),
          panelNames,
          Serializer,
        );

        // Update panel properties if needed
        if (
          newSelectedElement !== null &&
          panelNames.includes(newSelectedElement.name) &&
          newSelectedElement.isPanel
        ) {
          const panelJson = hardCodePanels.find(
            (panel: any) => panel.name === newSelectedElement.name,
          );
          const currentElementJson = newSelectedElement?.jsonObj;
          if (
            currentElementJson &&
            panelNames.includes(currentElementJson.name)
          ) {
            panelQuestionNames.forEach((panelElement: any) => {
              updatePropertyVisibility(
                panelElement,
                currentElementJson,
                Serializer,
              );
            });
          }

          newSelectedElement.onPropertyChanged.add(
            (panelSender: any, panelOptions: any) => {
              const findPanelJson = hardCodePanels.find(
                (item) => item.name === panelSender.name,
              );

              switch (true) {
                case panelOptions.name.startsWith("requireAll"):
                  const requireAll = newSelectedElement.getPropertyValue(
                    panelOptions.name,
                  );
                  if (panelSender.name !== panelsName.ALERT_TRIGGER) {
                    handleRequireAll(
                      panelSender,
                      newSelectedElement,
                      currentElementJson,
                      creator,
                      requireAll,
                      Serializer,
                    );
                  }
                  break;

                case panelOptions.name.startsWith("showAll"):
                  const showAll = newSelectedElement.getPropertyValue(
                    panelOptions.name,
                  );
                  if (panelSender.name !== panelsName.ALERT_TRIGGER) {
                    handleShowAll(
                      creator,
                      newSelectedElement,
                      panelSender,
                      showAll,
                      findPanelJson,
                      Serializer,
                    );
                  }
                  break;

                default:
                  handleOtherProperties(
                    creator,
                    newSelectedElement,
                    panelSender,
                    findPanelJson,
                    panelOptions,
                    Serializer,
                  );
                  break;
              }
            },
          );

          if (options.obj?.isQuestion) {
            options.obj.logicTitle = options.obj.title;
          }
        }

        // Update last selected panel logic
        if (
          newSelectedElement &&
          newSelectedElement.parent &&
          panelNames.includes(newSelectedElement.parent.name)
        ) {
          if (isMapQuestion) {
            lastSelectedDropdownWithinCustomPanel = parent;
          } else if (isQuestionTypeExist) {
            lastSelectedDropdownWithinCustomPanel = newSelectedElement;
          }
        }
      } catch (error) {
        console.error(
          "[SELECT] Error occurred during element changing:",
          error,
        );
      }
    });

    creator.onDragEnd.add((sender: any, options: any) => {
      const draggedElement = options.draggedElement;
      if (!draggedElement || !options.draggedElement.isPanel) {
        options.allow = true;
        return;
      }

      if (options.draggedElement.toolboxItemIconName === undefined) {
        return;
      }

      const panelName = options?.draggedElement?.toolboxItemIconName?.replace(
        "icon-",
        "",
      );
      if (
        options.draggedElement &&
        panelName &&
        panelNames.includes(panelName) &&
        draggedElement.isPanel
      ) {
        let panel = draggedElement;
        panel.name = panelName;
        panel.jsonObj.name = panelName;
        const panelJson = hardCodePanels.find(
          (panel: any) => panel.name === panelName,
        );
        panel.jsonObj = panelJson;

        // options.draggedElement.setPropertyValue("panelType", "static");

        // if (panel.jsonObj.name === panelsName.HARVEST) {
        //   const retrievalShapePicker = new ShapePickerState({
        //     mapCenterPoint: {
        //       longitude: -145.6433003,
        //       latitude: 65.0710178,
        //     },
        //   });
        //   const struckShapePicker = new ShapePickerState({
        //     mapCenterPoint: {
        //       longitude: -145.6433003,
        //       latitude: 65.0710178,
        //     },
        //   });
        //   const retrievalPointPicker = new PointPickerState({
        //     mapCenterPoint: {
        //       longitude: -145.6433003,
        //       latitude: 65.0710178,
        //     },
        //   });
        //   const struckPointPicker = new PointPickerState({
        //     mapCenterPoint: {
        //       longitude: -145.6433003,
        //       latitude: 65.0710178,
        //     },
        //   });

        //   const harvest = {
        //     id: generateUniqueId("harvest#"),
        //     retrievalShapePicker,
        //     struckShapePicker,
        //     retrievalPointPicker,
        //     struckPointPicker,
        //   };

        //   options.draggedElement._id = harvest.id;
        //   options.draggedElement.setPropertyValue("_id", harvest.id);
        //   dispatch(updateAddedHarvestPanelMapQuestions(harvest));
        // }
        if (panelJson) {
          draggedElement.elements.forEach((element: any, index: number) => {
            const jsonElement = panelJson.elements[index];
            if (jsonElement) {
              element.name = jsonElement.name;

              if (
                (element.getType() === questionTypes.tagbox ||
                  element.getType() === questionTypes.dropdown) &&
                element.choicesByUrl &&
                element.choicesByUrl.url
              ) {
                element.choices = setTheChoicesOfDropdowns(
                  jsonElement.name,
                  dataSourcesData,
                );
                element.jsonObj.choices = setTheChoicesOfDropdowns(
                  jsonElement.name,
                  dataSourcesData,
                );
              }
            }
          });
        }
        // debugger;
        let updatedJSON = creator.JSON;

        const panelInstances = updatedJSON?.pages?.flatMap((page: any) =>
          page.elements.filter(
            (e: any) => e.type === "panel" && e.name === panel.name,
          ),
        );

        const isDuplicate = panelInstances.length > 1;

        if (isDuplicate) {
          options.allow = false;
        } else {
          options.allow = true;
        }
      } else {
        options.allow = true;
      }
    });

    // creator.onDragStart.add((sender: any, options: any) => {
    //   const draggedElement = options.draggedElement;
    //   const target = options.target;
    //   if (!draggedElement || !options.draggedElement.isPanel) {
    //     options.allow = true;
    //     return;
    //   }

    //   if (options.draggedElement.toolboxItemIconName === undefined) {
    //     return;
    //   }

    //   const panelName = options?.draggedElement?.toolboxItemIconName?.replace(
    //     "icon-",
    //     ""
    //   );

    //   if (
    //     options.draggedElement &&
    //     panelName &&
    //     panelNames.includes(panelName)
    //   ) {
    //     let panel = draggedElement;
    //     panel.name = panelName;
    //     panel.jsonObj.name = panelName;
    //     const panelJson = hardCodePanels.find(
    //       (panel: any) => panel.name === panelName
    //     );
    //     panel.jsonObj = panelJson;

    //     // let updatedJSON = creator.JSON;

    //     // const panelInstances = updatedJSON.pages.flatMap((page: any) =>
    //     //   page.elements.filter(
    //     //     (e: any) => e.type === "panel" && e.name === panel.name
    //     //   )
    //     // );

    //     // const isDuplicate = panelInstances.length > 1;

    //     // if (isDuplicate) {
    //     //   const addedPanelIndex = updatedJSON.pages.findIndex(
    //     //     (page: any) =>
    //     //       page.elements.findIndex((e: any) => e.name === panel.name) !== -1
    //     //   );

    //     //   if (addedPanelIndex >= 0) {
    //     //     updatedJSON.pages[addedPanelIndex].elements = updatedJSON.pages[
    //     //       addedPanelIndex
    //     //     ].elements.filter(
    //     //       (e: any, index: any) =>
    //     //         !(e.name === panel.name && index === panelInstances.length - 1)
    //     //     );
    //     //     creator.JSON = updatedJSON;
    //     //   }
    //     // } else {
    //     //   options.allow = true;
    //     // }
    //     options.allow = true;
    //   } else {
    //     // Allow the drop if the above conditions are not met
    //     options.allow = true;
    //   }

    //   options.allow = true;
    // });

    creator.onActiveTabChanged.add((sender: any, option: any) => {
      const activeTabName = sender.activeTab;
      dispatch(updateSurveyActiveTab(activeTabName));
      handleActiveTabChange(sender, option);

      // if (activeTabName === "designer") {
      //   (async () => {
      //     const questions = sender.survey.getAllQuestions();

      //     const updatePromises = questions
      //       .filter((q: any) => q.choicesByUrl && q.choicesByUrl.url)
      //       .map(async (question: any) => {
      //         const url = question.choicesByUrl.url;
      //         const newChoices = await getDataFromSourceUrl(url);

      //         question.choices = newChoices;
      //         question.choicesByUrl.titleName = "text";
      //         question.choicesByUrl.valueName = "value";

      //         question.jsonObj.choices = newChoices;

      //         question.setPropertyValue("dataSourceDetached", false);
      //         question.setPropertyValue("serviceUrls", url);
      //         question.setPropertyValue(
      //           "dataSourceType",
      //           extractDataSourceType(url)
      //         );
      //       });

      //     await Promise.all(updatePromises);
      //   })();
      // }
    });

    creator.onShowingProperty.add(function (sender: any, options: any) {
      options.canShow = propertyStopList.indexOf(options.property.name) == -1;

      if (isHiddenDynamicMatrixColumnProperty(options)) {
        options.showProperty = false;
        options.canShow = false;
        return;
      }

      if (!options.property.name && !options?.obj?.toJSON()?.name) return;

      if (
        propertiesToHide.includes(options.property.name) &&
        panelNames.includes(options.obj.toJSON().name)
      ) {
        options.showProperty =
          options.property.name === "visibleIf" &&
          panelsName.ALERT_TRIGGER === options.obj.toJSON().name;
        options.canShow =
          options.property.name === "visibleIf" &&
          panelsName.ALERT_TRIGGER === options.obj.toJSON().name;
      }
      // if (options.obj.parent && options.obj.parent.getType() === "panel") {
      //   if (panelNames.includes(options.obj.parent.name)) {
      //     if (options.obj.isQuestion && options.property.name !== "choices") {
      //       options.showProperty = false;
      //       options.canShow = false;
      //     }
      //   }
      // }

      creator.onShowingProperty.add(function (sender: any, options: any) {
        if (!options.property.name && !options?.obj?.toJSON()?.name) return;

        if (
          propertiesToHide.includes(options.property.name) &&
          panelNames.includes(options.obj.toJSON().name)
        ) {
          options.showProperty =
            options.property.name === "visibleIf" &&
            panelsName.ALERT_TRIGGER === options.obj.toJSON().name;
          options.canShow =
            options.property.name === "visibleIf" &&
            panelsName.ALERT_TRIGGER === options.obj.toJSON().name;
        }
        if (options.obj.parent && options.obj.parent.getType() === "panel") {
          if (panelNames.includes(options.obj.parent.name)) {
            const isDataSourceAttached = options?.obj?.jsonObj.choicesByUrl
              ? true
              : false;
            const isQuestionTypeExist = [
              questionTypes.checkbox,
              questionTypes.dropdown,
              questionTypes.tagbox,
              questionTypes.radio,
              questionTypes.text,
              questionTypes.boolean,
            ].includes(options.obj.getType());

            const isPropertyExist = isDataSourceAttached
              ? ["defaultValue", "colCount"].includes(options.property.name)
              : ["choices", "defaultValue", "colCount"].includes(
                  options.property.name,
                );
            if (
              options.obj.isQuestion &&
              isQuestionTypeExist &&
              isPropertyExist
            ) {
              if (options.obj.parent.name === panelsName.ALERT_TRIGGER) {
                options.showProperty = options.obj.name === "message";
                options.canShow = options.obj.name === "message";
              } else {
                options.showProperty = true;
                options.canShow = true;
              }
            } else {
              options.showProperty = false;
              options.canShow = false;
            }
          }
        }
      });
    });
  }, [creator, dataSourcesData]);

  useEffect(() => {
    return () => {
      dispatch(resetFormDetailsAction());
    };
  }, []);

  useEffect(() => {
    if (!creator) return;

    Serializer.addProperty("checkbox", {
      name: "checkboxLayoutText",
      type: "text",
      category: "layout",
      readOnly: true,
      visibleIndex: 2,
      displayName:
        "Please be aware that column counts larger than two can only be applied to the observer web view. For mobile devices, the maximum amount of columns that can be applied is two.",
      baseClassName: "checkboxLayoutText",
      visibleIf: function (obj) {
        return obj.getType() === "checkbox"; // Only visible for checkbox types
      },
    });
  }, [creator]);

  useEffect(() => {
    if (!creator) return;
    if (formDetails.formFields?.pages) {
      const newJson = structureFormJSON(
        formDetails?.formFields,
        panelsJson,
        [],
        "response",
        dataSourcesData,
      );

      creator.JSON = limitDynamicMatrixColumns(newJson);
    }
  }, [formDetails, creator]);

  if (creator) {
    return (
      <>
        <div
          className="flex-col items-start justify-start w-full "
          style={{ display: doHide ? "none" : "flex" }}
        >
          <Header creator={creator} dataSourcesData={dataSourcesData} />
        </div>
        <div
          className=" flex-col justify-start items-start h-[85.3vh] w-[100%] dynamic-form-surveyjs relative "
          style={{ display: doHide ? "none" : "flex" }}
        >
          <SurveyCreatorComponent creator={creator} />
          {customSidebarContainer &&
            createPortal(<CustomPropertyGridSidebar />, customSidebarContainer)}
          {isLoading && (
            <div className="absolute z-50 bg-bgWhite h-full top-0 bg-opacity-70 w-full flex items-center justify-center">
              <TailSpin
                height="60"
                width="60"
                color={primaryColor}
                ariaLabel="tail-spin-loading"
                radius="2"
                wrapperStyle={{}}
                wrapperClass="tailspin-loader"
                visible={true}
              />
            </div>
          )}
        </div>

        <HandlerComponent />
      </>
    );
  }
  return (
    <div className="loader min-h-[100vh] justify-center items-center flex w-full">
      <TailSpin
        height="50"
        width="50"
        color={primaryColor}
        ariaLabel="tail-spin-loading"
        radius="2"
        wrapperStyle={{}}
        wrapperClass="tailspin-loader"
        visible={true}
      />
    </div>
  );
};
function checkElementIsPanel(type: string) {
  const panels = Object.values(panelsName);

  if (panels.includes(type) || questionTypes.paneldynamic === type) {
    return true;
  }

  return false;
}

async function getDataFromSourceUrl(url: string) {
  const { data } = await axios.get(url);

  return data;
}

function updateChoicesByUrl(questionType: string) {
  const formDetsils: IFormDetails =
    store?.getState()?.formSurveyJsDetails?.formDetails;

  let dataSources: any[];
  if (questionType === questionTypes.dropdown) {
    // dataSources.push("dropdown");
    dataSources = [
      "Objects",
      "Species",
      "Categories",
      "Types",
      "Observers",
      "Behaviors",
      "Conditions",
      "Stations",
      "Regions",
      "Shapes",
      "Points",
    ];
  } else {
    dataSources = [
      "Objects",
      "Species",
      "Categories",
      "Types",
      "Observers",
      "Behaviors",
      "Conditions",
      "Stations",
    ];
  }

  const dataSourcesUrls = dataSources.map((source: string) => {
    if (formDetsils.programId) {
      return {
        value: `${baseURL}/common/dropdown/${source?.toLowerCase()}?token=5iRwAVXnFrQYJ3wtbr6gs3wCZYimIoUup5nwYU323GRrG/OspKqITSWosGqmhimT&program_id=${formDetsils.programId}`,
        text: source,
      };
    }
    return {
      value: ``,
      text: source,
    };
  });
  return dataSourcesUrls;
}

function setChoicesByUrl(urlKey: string, programId: string | null) {
  return {
    url: `${baseURL}/common/dropdown/${urlKey}?token=5iRwAVXnFrQYJ3wtbr6gs3wCZYimIoUup5nwYU323GRrG/OspKqITSWosGqmhimT&program_id=${programId}`,
    valueName: "value",
    titleName: "text",
  };
}

function addPropertyForRadioCheckBoxesTagboxAndDropdown() {
  const questions = [
    questionTypes.dropdown,
    questionTypes.tagbox,
    questionTypes.radio,
    questionTypes.checkbox,
  ];
  questions.forEach((question) => {
    Serializer.addProperty(question, {
      name: `dataSourceDetached:boolean`,
      default: false,
      visible: false,
      displayName: "dataSourceDetached",
      category: "general",
    });

    Serializer.addProperty(question, {
      name: `dataSourceType`,
      type: "text",
      default: "",
      visible: false,
      displayName: "dataSourceType",
      category: "general",
    });
  });
}

function extractDataSourceType(url: string) {
  try {
    // Create a URL object
    const parsedUrl = new URL(url);

    // Get the pathname from the URL
    const pathname = parsedUrl.pathname;

    // Split the pathname to isolate parts
    const segments = pathname.split("/");

    // The segment after 'dropdown/' is typically the third element after splitting by '/'
    const dataSourceType = segments[segments.indexOf("dropdown") + 1];

    return dataSourceType;
  } catch (error) {
    console.error("Invalid URL:", error);
    return "";
  }
}

var defaultImagePickerChoices = [
  {
    imageLink:
      "https://s3.us-west-2.amazonaws.com/isn-s3/isn/public/1/original/50322-1757478303962105.jpg",
    value: "Image 1",
  },
  {
    imageLink:
      "https://s3.us-west-2.amazonaws.com/isn-s3/isn/public/1/original/16579-1757478373212070.jpg",
    value: "Image 2",
  },
  {
    imageLink:
      "https://s3.us-west-2.amazonaws.com/isn-s3/isn/public/1/original/16611-1757478413438064.jpg",
    value: "Image 3",
  },
  {
    imageLink:
      "https://s3.us-west-2.amazonaws.com/isn-s3/isn/public/1/original/16627-1757478457664086.jpg",
    value: "Image 4",
  },
];
